export default __webpack_public_path__ + "static/media/onboarding-graphic-right.7b61c61f.svg";